'import { FC, PropsWithChildren, useContext } from ';
import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { Colors } from './types';

interface ThemeContextProps {
  COLORS: Colors;
  DEFAULT_BORDER_RADIOS: string;
}

const ThemeContext = createContext<ThemeContextProps>({ COLORS: {} as Colors, DEFAULT_BORDER_RADIOS: '' });

interface ThemeProviderProps extends PropsWithChildren {
  colors: Colors;
  borderRadiusDefault: string;
}

const ColorsProvider: FC<ThemeProviderProps> = ({ children, colors, borderRadiusDefault }) => (
  <ThemeContext.Provider
    value={{
      COLORS: colors,
      DEFAULT_BORDER_RADIOS: borderRadiusDefault,
    }}
  >
    {children}
  </ThemeContext.Provider>
);

const useTheme = (): ThemeContextProps => useContext(ThemeContext);

export { ColorsProvider, useTheme };
